module.exports = __webpack_public_path__ + "static/media/step4_14_m.5f3e393e.png";